module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nxx-35d0e72fe6fedc9601131f419f95868f.png";